var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 16.6667C15.7339 16.6667 16.6667 15.7339 16.6667 14.5833C16.6667 13.4327 15.7339 12.5 14.5833 12.5C13.4327 12.5 12.5 13.4327 12.5 14.5833C12.5 15.7339 13.4327 16.6667 14.5833 16.6667Z",
    fill: "url(#paint0_linear_4_33358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9154 16.6667C24.066 16.6667 24.9987 15.7339 24.9987 14.5833C24.9987 13.4327 24.066 12.5 22.9154 12.5C21.7648 12.5 20.832 13.4327 20.832 14.5833C20.832 15.7339 21.7648 16.6667 22.9154 16.6667Z",
    fill: "url(#paint1_linear_4_33358)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2493 16.6667C32.3999 16.6667 33.3327 15.7339 33.3327 14.5833C33.3327 13.4327 32.3999 12.5 31.2493 12.5C30.0988 12.5 29.166 13.4327 29.166 14.5833C29.166 15.7339 30.0988 16.6667 31.2493 16.6667Z",
    fill: "url(#paint2_linear_4_33358)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5833 16.6667H85.4167C86.5625 16.6667 87.5 15.7292 87.5 14.5833C87.5 13.4375 86.5625 12.5 85.4167 12.5H64.5833C63.4375 12.5 62.5 13.4375 62.5 14.5833C62.5 15.7292 63.4375 16.6667 64.5833 16.6667Z",
    fill: "url(#paint3_linear_4_33358)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4994 4.16663H12.4993C7.89518 4.16663 4.16602 7.89579 4.16602 12.5V50C4.16602 54.6041 7.89518 58.3333 12.4993 58.3333H47.916V64.5833H20.8327C17.3952 64.5833 14.5827 67.3958 14.5827 70.8333V75H10.416C6.97852 75 4.16602 77.8125 4.16602 81.25V89.5833C4.16602 93.0208 6.97852 95.8333 10.416 95.8333H22.916C26.3535 95.8333 29.166 93.0208 29.166 89.5833V81.25C29.166 77.8125 26.3535 75 22.916 75H18.7493V70.8333C18.7493 69.6875 19.6869 68.75 20.8327 68.75H47.916V75H43.7494C40.3119 75 37.4994 77.8125 37.4994 81.25V89.5833C37.4994 93.0208 40.3119 95.8333 43.7494 95.8333H56.2494C59.6869 95.8333 62.4994 93.0208 62.4994 89.5833V81.25C62.4994 77.8125 59.6869 75 56.2494 75H52.0827V68.75H79.166C80.3119 68.75 81.2494 69.6875 81.2494 70.8333V75H77.0827C73.6452 75 70.8327 77.8125 70.8327 81.25V89.5833C70.8327 93.0208 73.6452 95.8333 77.0827 95.8333H89.5827C93.0202 95.8333 95.8327 93.0208 95.8327 89.5833V81.25C95.8327 77.8125 93.0202 75 89.5827 75H85.416V70.8333C85.416 67.3958 82.6035 64.5833 79.166 64.5833H52.0827V58.3333H87.4994C92.1035 58.3333 95.8327 54.6041 95.8327 50V12.5C95.8327 7.89579 92.1035 4.16663 87.4994 4.16663ZM24.9994 81.25V89.5833C24.9994 90.7291 24.0618 91.6666 22.916 91.6666H10.416C9.27018 91.6666 8.33268 90.7291 8.33268 89.5833V81.25C8.33268 80.1041 9.27018 79.1666 10.416 79.1666H22.916C24.0618 79.1666 24.9994 80.1041 24.9994 81.25ZM58.3327 81.25V89.5833C58.3327 90.7291 57.3952 91.6666 56.2494 91.6666H43.7494C42.6035 91.6666 41.666 90.7291 41.666 89.5833V81.25C41.666 80.1041 42.6035 79.1666 43.7494 79.1666H56.2494C57.3952 79.1666 58.3327 80.1041 58.3327 81.25ZM91.666 81.25V89.5833C91.666 90.7291 90.7285 91.6666 89.5827 91.6666H77.0827C75.9369 91.6666 74.9994 90.7291 74.9994 89.5833V81.25C74.9994 80.1041 75.9369 79.1666 77.0827 79.1666H89.5827C90.7285 79.1666 91.666 80.1041 91.666 81.25ZM12.4993 8.33329H87.4994C89.791 8.33329 91.666 10.2083 91.666 12.5V20.8333H8.33268V12.5C8.33268 10.2083 10.2077 8.33329 12.4993 8.33329ZM27.0827 50H14.5827C13.4368 50 12.4993 49.0625 12.4993 47.9166C12.4993 46.7708 13.4368 45.8333 14.5827 45.8333H27.0827C28.2285 45.8333 29.166 46.7708 29.166 47.9166C29.166 49.0625 28.2285 50 27.0827 50ZM27.0827 41.6666H14.5827C13.4368 41.6666 12.4993 40.7291 12.4993 39.5833C12.4993 38.4375 13.4368 37.5 14.5827 37.5H27.0827C28.2285 37.5 29.166 38.4375 29.166 39.5833C29.166 40.7291 28.2285 41.6666 27.0827 41.6666ZM27.0827 33.3333H14.5827C13.4368 33.3333 12.4993 32.3958 12.4993 31.25C12.4993 30.1041 13.4368 29.1666 14.5827 29.1666H27.0827C28.2285 29.1666 29.166 30.1041 29.166 31.25C29.166 32.3958 28.2285 33.3333 27.0827 33.3333ZM85.416 50H35.416C34.2702 50 33.3327 49.0625 33.3327 47.9166C33.3327 46.7708 34.2702 45.8333 35.416 45.8333H85.416C86.5619 45.8333 87.4994 46.7708 87.4994 47.9166C87.4994 49.0625 86.5619 50 85.416 50ZM85.416 41.6666H35.416C34.2702 41.6666 33.3327 40.7291 33.3327 39.5833C33.3327 38.4375 34.2702 37.5 35.416 37.5H85.416C86.5619 37.5 87.4994 38.4375 87.4994 39.5833C87.4994 40.7291 86.5619 41.6666 85.416 41.6666ZM85.416 33.3333H35.416C34.2702 33.3333 33.3327 32.3958 33.3327 31.25C33.3327 30.1041 34.2702 29.1666 35.416 29.1666H85.416C86.5619 29.1666 87.4994 30.1041 87.4994 31.25C87.4994 32.3958 86.5619 33.3333 85.416 33.3333Z",
    fill: "url(#paint4_linear_4_33358)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_33358",
    x1: 12.5636,
    y1: 12.5991,
    x2: 17.1623,
    y2: 17.1979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_33358",
    x1: 20.8956,
    y1: 12.5991,
    x2: 25.4944,
    y2: 17.1979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_33358",
    x1: 29.2296,
    y1: 12.5991,
    x2: 33.8284,
    y2: 17.1979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_33358",
    x1: 62.8817,
    y1: 12.5991,
    x2: 64.3732,
    y2: 21.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_33358",
    x1: 5.56563,
    y1: 6.34763,
    x2: 106.738,
    y2: 107.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/Seo.5a1cfc42375b4efdacb32c8482ae98f4.svg";
export { ForwardRef as ReactComponent };